export function getEmployeeProfileImage(employee) {
  return (
    employee?.image ||
    employee?.checkin_image ||
    employee?.checkin_face?.image_url ||
    null
  );
}
